/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * Import Context
 */

import { AppContext } from "context/appContext";
import { ContentContext } from "context/contentContext";

/**
 * import components
 */

import { Shadow__container } from "components/shadow/shadow";
import { Item__filter } from "components/item/item";

/**
 * styled components
 */

const Container = styled.div`
  ${t.mixins.flex({ wrap: "wrap" })}
  justify-content: flex-start;

`;

const Shadow = styled(Shadow__container)`
  padding: 48px;
  margin-bottom: 48px;

  ${t.mixins.sm(`
    padding: 0 26px;
    margin-bottom: 26px;
  `)}
`;
/**
 * filters component is..
 */

const List__filters = ({ filters }) => {
  const { t } = useContext(AppContext);
  const { c } = useContext(ContentContext);
  return (
    <Shadow title={c("home.filters.title")}>
      <Container>
        {filters.map(filter => {
          const { title, id, display, tooltip } = filter;
          if (!display) return;
          return <Item__filter key={id} title={t(title)} id={id} tooltip={tooltip} />;
        })}
      </Container>
    </Shadow>
  );
};

export default List__filters;

List__filters.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

List__filters.defaultProps = {
  style: {},
};

/*
    import List__filters from 'components/list/filters/list__filters'
    <List__filters />
  */
